<!--公路安全设施监测感知报警系统-->
<template>
	<div class="system-container">
		<div class="section">
			<div class="section-content">
				<div class="title">平台概述</div>
				<p class="text">
					公路安全设施监测感知报警系统设备适用于桥梁水毁、灾毁、滑坡、泥石流灾害、车船撞击等多种场景的感知报警，如地质灾害易发区、跨线桥、大曲率匝道、事故易发区、病害突出桥梁及高大边坡，具有多功能、低成本、高可靠、低延迟等特点，可实现灾害下的主动警示拦阻、报警信息推送、快速应对处置，避免群死群伤事件的发生。
				</p>
				<img class="image" src="@/assets/image/prescription/fun_model3.png" alt />
			</div>
		</div>
		<div class="section" style="background-color: #EAF3FF">
			<div class="section-content">
				<div class="title">系统组成</div>
				<p class="text">
					公路安全设施监测感知报警系统由监测感知单元、视频感知单元、智能网关及主被动警示单元、软件管理云平台组成，通过对设备各单元模块的快速组合和灵活裁剪，可迅速建立面向不同风险场景和桥梁养护需求的监测体系，真正实现功能匹配、场景适用。
				</p>
				<img class="image" src="@/assets/image/prescription/fun_model4.png" alt />
			</div>
		</div>
		<div class="section">
			<div class="section-content">
				<div class="title">系统功能</div>
				<div class="panel-content">
					<div class="panel" v-for="(item,index) in panelList" :key="index">
						<img class="image" :src="item.icon" style="width: 60px;height: 60px;" alt />
						<div>
							<div class="label">{{ item.label }}</div>
							<p class="info">{{ item.text }}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	//components
	import Carousel from '@/components/Carousel';

	export default {
		components: {
			Carousel
		},
		name: 'freewayDecision',
		data() {
			return {
				imageList: [
					require('@/assets/image/prescription/sys_1.png'),
					require('@/assets/image/prescription/sys_2.png'),
					require('@/assets/image/prescription/sys_3.png')
				],
				panelList: [{
						icon: require('@/assets/image/prescription/icon_20.png'),
						label: '高度集成一体化',
						text: '支持全天候的振动、倾角、温度等参数的监测报警与位移、裂缝、激光雷达等多参数的一体化数据采集功能。'
					},
					{
						icon: require('@/assets/image/prescription/icon_21.png'),
						label: '边缘计算',
						text: '具备边缘计算能力，可实现数据预处理、超限阈值远程设置。'
					},
					{
						icon: require('@/assets/image/prescription/icon_22.png'),
						label: '多工作模式',
						text: '具备连续测量、定时测量以及触发报警等多种工作模式。'
					}, {
						icon: require('@/assets/image/prescription/icon_23.png'),
						label: '多途径报警',
						text: '支持短信、app、平台、微信、邮件等多种报警推送方式。'
					},
					{
						icon: require('@/assets/image/prescription/icon_24.png'),
						label: '视频联动零误报',
						text: '具备视频回溯、联动抓拍功能；并可利用边缘计算、数据预处理和多源异构数据融合预警算法，实现零误报，从源头降低由于设备误报带来的次生灾害和不可估量的法律风险。'
					},
					{
						icon: require('@/assets/image/prescription/icon_25.png'),
						label: '数据上报，超低延迟',
						text: '可上报报警前后一段时间的测量数据（可配置，时间不低于5s），前端报警触发延迟小于0.5s。'
					}, {
						icon: require('@/assets/image/prescription/icon_26.png'),
						label: '极端条件稳定报警',
						text: '警示装置通过前端触发，无需4G/5G网络，并且具备北斗短报文功能，在极端断网条件下，仍可发送报警信息至管养人员手机。'
					},
					{
						icon: require('@/assets/image/prescription/icon_27.png'),
						label: '超低功耗，全天候工作',
						text: '设备具备超低功耗工作模式，支持市电供电或者太阳能供电，太阳能供电可实现7×24小时全天候持续工作，供电中断时，具备本地自动供电能力，且报警信息持续发布不少于30分钟。'
					},
					{
						icon: require('@/assets/image/prescription/icon_28.png'),
						label: '全域无线自组网',
						text: '设备全部支持无线自组网，无需布线，实现便捷施工。'
					},
					{
						icon: require('@/assets/image/prescription/icon_29.png'),
						label: '超强环境适应性',
						text: '桥梁简易感知报警设备具备极强的环境适应性，在野外恶劣环境下，可长期稳定工作，MTBF≥50000小时。'
					}
				],
				mobileCoreList: [{
						label: '专题“可视化驾驶舱”',
						img: require('@/assets/image/prescription/icon_20_small.png')
					},
					{
						label: '路网数据管理',
						img: require('@/assets/image/prescription/icon_11_small.png')
					},
					{
						label: '路产数据管理',
						img: require('@/assets/image/prescription/icon_12_small.png')
					},
					{
						label: '桥隧构造物评价',
						img: require('@/assets/image/prescription/icon_14_small.png')
					},
					{
						label: '公路技术状况评价',
						img: require('@/assets/image/prescription/icon_15_small.png')
					},
					{
						label: '路面性能预测',
						img: require('@/assets/image/prescription/icon_16_small.png')
					},
					{
						label: '养护决策分析',
						img: require('@/assets/image/prescription/icon_17_small.png')
					},
					{
						label: '养护报告导出',
						img: require('@/assets/image/prescription/icon_18_small.png')
					},
					{
						label: '综合数据统计',
						img: require('@/assets/image/prescription/icon_19_small.png')
					},
				]
			};
		},
		mounted() {},
		methods: {
			//切换图片
			toggleImage(type) {
				this.$refs.carousel[type]();
			}
		}
	}
</script>


<style scoped lang="scss">
	.system-container {
		height: 100%;
		width: 100%;

		.section {
			height: 100%;
			width: 100%;

			.section-content {
				margin: 0 auto;
				width: 1200px;
				padding: 50px 0;
				text-align: center;

				.title {
					text-align: center;
					font-size: 32px;
				}

				.text {
					margin-top: 40px;
					text-indent: 2em;
					line-height: 32px;
					font-size: 20px;
					text-align: justify;
				}

				.image {
					margin-top: 60px;
					width: 1020px;
				}
			}
		}

		.panel-content {
			margin-top: 50px;
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;

			.panel {
				box-sizing: border-box;
				width: calc(100% / 3 - 16px);
				padding: 30px;
				box-shadow: 0 3px 18px 1px rgba(26, 102, 187, 0.14);
				margin-bottom: 24px;

				.label {
					padding: 30px 0;
					font-size: 24px;
					font-weight: bold;
				}

				.info {
					line-height: 32px;
					font-size: 20px;
				}
			}
		}

		.mobile-core {
			display: none;
		}

		.core {
			.core-list {
				margin-top: 24px;
				font-size: 20px;
				display: grid;
				grid-template-columns: repeat(5, 1fr);
				grid-template-rows: repeat(2, 1fr);
				grid-gap: 24px;

				.first {
					grid-row-start: 1;
					grid-row-end: 3;
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: center;
				}

				.core-item {
					background-color: #ffffff;
					border-radius: 4px;
					padding: 20px;

					.mobile_image {
						width: 60px;
						height: 60px;
					}

					.mobile_label {
						line-height: 30px;
					}
				}
			}
		}
	}

	@import "./style.scss";
</style>